<template>
    <div>
        <div class="report-heading">
            <div class="text-left">
                <h1>
                    {{ title }}
                    <span class="period">
                        ({{ periodStart }} - {{ periodEnd }})
                    </span>
                </h1>
            </div>

            <div class="text-right">
                <i class="timestamp">Results as of {{ billingHeaderTime() }}</i>
                <div class="font-italic">
                    <actor-name
                        v-if="_timeZone"
                        :actor="$root.currentActor"
                        :use-encoded="true"
                        :text="_timeZone.replace('_', '')"
                    />
                </div>
            </div>
        </div>

        <b-card>
            <div id="report-body" class="w-100">
                <QTable
                    :columns="columns"
                    :data="tableData"
                    hide-bottom
                    :loading="isLoading"
                    class="mb-4"
                    :rows-per-page-options="[0]"
                    row-key="desc"
                >
                    <template
                        v-slot:bottom-row
                        v-if="tableData.length == 0 && !isLoading"
                    >
                        <q-tr>
                            <q-td colspan="5">No records available</q-td>
                        </q-tr>
                    </template>
                    <template v-slot:body-cell-reference="props">
                        <td>
                            <a
                                v-if="props.row.encoded_id"
                                :href="`${ci}billing/invoice/view/${props.row.encoded_id}`"
                            >
                                {{ props.value }}
                            </a>
                            <span v-else>
                                {{ props.value }}
                            </span>
                        </td>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>

<script>
import { QTable } from "quasar";
import "@/css/quasar-table.css";
import Report from "@/mixins/report.js";
export default {
    mixins: [Report],
    components: {
        QTable,
        ActorName: () => import("@/components/commons/actor-name.vue")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: moment(),
                    end: moment()
                };
            }
        }
    },
    data() {
        return {
            columns: [
                {
                    name: "date",
                    field: "date",
                    label: "Date",
                    align: "left",
                    headerStyle: "width:200px; font-weight:bold;"
                },
                {
                    name: "reference",
                    field: "reference",
                    label: "Reference",
                    align: "left",
                    headerStyle: "font-weight:bold;"
                },
                {
                    name: "summary",
                    field: "summary",
                    label: "Summary",
                    align: "left",
                    headerStyle: "font-weight:bold;"
                },
                {
                    name: "updated_by",
                    field: "updated_by",
                    label: "Updated By",
                    align: "left",
                    headerStyle: "font-weight:bold;"
                },
                {
                    name: "approve_by",
                    field: "approve_by",
                    label: "Approved By",
                    align: "left",
                    headerStyle: "font-weight:bold;"
                }
            ],
            tableData: [],
            isLoading: true,
            ci: process.env.CI_APPS,
            title: "Out Of Period Adjustments"
        };
    },
    computed: {
        periodStart() {
            if (this.data.start) {
                return this.data.start.format(this.getDateFormat());
            }
            return null;
        },
        periodEnd() {
            if (this.data.end) {
                return this.data.end.format(this.getDateFormat());
            }
            return null;
        }
    },
    async mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.isShowDateRange = true;

        await self._getSetting();
        self.data.start = moment().tz(self._timeZone).startOf("week");
        self.data.end = moment().tz(self._timeZone).endOf("day");
        self.data.from = moment().tz(self._timeZone).startOf("week").unix();
        self.data.to = moment().tz(self._timeZone).endOf("day").unix();
        self.fetchData();

        self.$root.$on("report-filter-date-range:refresh", self.fetchData);
        self.$root.$on("report-unique-name:refresh", function () {
            self.refresh = 1;
            self.fetchData();
        });

        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.$root.$off("report-filter-date-range:refresh", this.fetchData);
    },
    methods: {
        showDate(val) {
            return moment.unix(val).tz(this._timeZone).format(this.dateFormat);
        },
        async fetchData() {
            this.isLoading = true;

            let res = await this.$http.get(
                `${process.env.BARRAMUNDI}report/reports/46`,
                {
                    params: {
                        from: this.data.from,
                        to: this.data.to,
                        refresh: this.data.refresh
                    }
                }
            );

            this.isLoading = false;
            let response = res.data.response;
            this.dynamicPageTitle(this.title);

            if (response.message && response.message.code === 200) {
                this.tableData = response.resource.results.result_summary;
            } else {
                this.tableData = [];
            }
        }
    }
};
</script>

<style scoped>
.report-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 5px;
}
.report-heading .period {
    font-size: 0.7em;
}
th {
    font-weight: bold;
    white-space: nowrap;
}
.card-body {
    padding-top: 0;
    padding-bottom: 0;
}
.report-description {
    display: block;
    margin-bottom: 10px;
    font-style: italic;
}
.total {
    font-weight: bold;
    border-top: 3px double #e4e4e4;
}
</style>
